import QRCode from 'qrcode';

// Generate QR code as data URL
export const generateQRCode = async (url: string, options = {}): Promise<string> => {
  try {
    const defaultOptions = {
      errorCorrectionLevel: 'H',
      margin: 1,
      width: 300,
      color: {
        dark: '#000000',
        light: '#FFFFFF',
      },
    };

    const mergedOptions = { ...defaultOptions, ...options };
    const dataUrl = await QRCode.toDataURL(url, mergedOptions);
    return dataUrl;
  } catch (error) {throw error;
  }
};

// Download QR code as PNG
export const downloadQRCode = (dataUrl: string, fileName = 'qr-code'): void => {
  const link = document.createElement('a');
  link.href = dataUrl;
  link.download = `${fileName}.png`;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};

// Generate QR code as SVG
export const generateQRCodeSVG = async (url: string, options = {}): Promise<string> => {
  try {
    const defaultOptions = {
      errorCorrectionLevel: 'H',
      margin: 1,
      width: 300,
      color: {
        dark: '#000000',
        light: '#FFFFFF',
      },
    };

    const mergedOptions = { ...defaultOptions, ...options };
    const svg = await QRCode.toString(url, { 
      ...mergedOptions, 
      type: 'svg' 
    });
    return svg;
  } catch (error) {throw error;
  }
};